/* ==============================================================================================
 * ABBREVIATION TABLE COMPONENT
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var list = document.querySelector("[data-feature=alphabetSelector]");

	if (!list) {
		return;
	}

	var letters = list.querySelectorAll("[data-alphabet-letter]");
	var activeClass = "c-alphabetSelector__letter--active";

	/** @type { HTMLAnchorElement } */
	var selectedElement;

	if (window.location.hash) {
		selectedElement = list.querySelector("[href='" + window.location.hash + "']");
		selectedElement.classList.add(activeClass);
	}

	/**
	 * @return {void}
	 */
	function handleLetterClick(clickedLetter) {
		clickedLetter.addEventListener("click", function () {
			if (selectedElement) {
				selectedElement.classList.remove(activeClass);
			}

			selectedElement = clickedLetter;
			selectedElement.classList.add(activeClass);
		});
	}

	Sushi.Dom.forEach(letters, handleLetterClick);

})(Sushi || (Sushi = {}));
